import MyTimeSheetTable from "components/tables/practice/MyTimeSheetTable";

const MyTimeSheet = () => {
  return (
    <>
    <div className="admin-practice-details">
     <MyTimeSheetTable />
    </div>
    </>
  );
};

export default MyTimeSheet;
